import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "admin_application_drawer",
  class: "bg-body",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "explore",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'600px', 'lg': '775px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#admin_application_drawer_toggle",
  "data-kt-drawer-close": "#admin_application_drawer_toggle"
}
const _hoisted_2 = { class: "card-body p-7 pt-4 shadow-none w-100" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "pb-1 pe-2" }, "Document Actions", -1)
const _hoisted_6 = { class: "pb-8 pe-2 fs-7" }
const _hoisted_7 = { class: "col text-end" }
const _hoisted_8 = {
  id: "kt_horizontal_search_advanced_link",
  class: "btn btn-sm btn-light btn-active-light-primary p-1 ps-4 pe-4 fs-9 me-2",
  "data-bs-toggle": "collapse",
  href: "#kt_advanced_search_form"
}
const _hoisted_9 = { class: "svg-icon svg-icon fs-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Hidden Files ")
const _hoisted_11 = {
  id: "kt_horizontal_search_advanced_link2",
  href: "#kt_advanced_search_form2",
  class: "btn btn-sm btn-light btn-active-light-primary p-1 ps-4 pe-4 fs-9 me-2",
  "data-bs-toggle": "collapse"
}
const _hoisted_12 = { class: "svg-icon svg-icon fs-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" History ")
const _hoisted_14 = {
  href: "#",
  class: "btn btn-sm btn-light btn-active-light-primary p-1 ps-4 pe-4 fs-9 me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#edit_application_modal"
}
const _hoisted_15 = { class: "svg-icon svg-icon fs-2" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Add Document ")
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  class: "accordion pt-5",
  id: "welcome_accordion"
}
const _hoisted_19 = { class: "accordion-item" }
const _hoisted_20 = ["id"]
const _hoisted_21 = ["data-bs-target", "aria-controls"]
const _hoisted_22 = { class: "me-5" }
const _hoisted_23 = {
  key: 0,
  class: "svg-icon-primary"
}
const _hoisted_24 = { class: "svg-icon btn-icon svg-icon-2 svg-icon-danger" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "svg-icon btn-icon svg-icon-2 svg-icon-success" }
const _hoisted_27 = ["id", "aria-labelledby"]
const _hoisted_28 = {
  key: 0,
  class: "accordion-body"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = {
  key: 0,
  class: "col-md-2 fv-row"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 1,
  class: "col-md-2 fv-row"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 2,
  class: "col-md-2 fv-row"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 3,
  class: "col-md-2 fv-row"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "col-md-2 fv-row" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "col-md-2 fv-row" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "col-md-2 fv-row" }
const _hoisted_43 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_sms_message"
}
const _hoisted_44 = { class: "svg-icon btn-icon svg-icon-2qx" }
const _hoisted_45 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_email_message"
}
const _hoisted_46 = { class: "svg-icon btn-icon svg-icon-2qx" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-12 fv-row text-end" }
const _hoisted_49 = { class: "modal-body ps-0 pe-0" }
const _hoisted_50 = ["src"]
const _hoisted_51 = {
  key: 1,
  class: "accordion-body"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100 disabled"
  }, " Approve ")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100 disabled"
  }, " Deny ")
], -1)
const _hoisted_55 = { class: "col-md-2 fv-row" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "col-md-2 fv-row" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "col-md-2 fv-row" }
const _hoisted_60 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_sms_message"
}
const _hoisted_61 = { class: "svg-icon btn-icon svg-icon-2qx" }
const _hoisted_62 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_email_message"
}
const _hoisted_63 = { class: "svg-icon btn-icon svg-icon-2qx" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-12 fv-row text-end" }
const _hoisted_66 = { class: "modal-body ps-0 pe-0" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "text-center pt-5 text-gray-400 fw-bold" }, " Not Uploaded ", -1)
const _hoisted_69 = { class: "col-12 fv-row text-end" }
const _hoisted_70 = { class: "modal-body ps-0 pe-0" }
const _hoisted_71 = {
  class: "collapse",
  id: "kt_advanced_search_form"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "mt-7 pb-1 pe-2 fs-7 text-gray-600" }, "Hidden Files", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-7" }, null, -1)
const _hoisted_74 = { class: "row" }
const _hoisted_75 = {
  class: "accordion",
  id: "welcome_accordion"
}
const _hoisted_76 = { class: "accordion-item" }
const _hoisted_77 = ["id"]
const _hoisted_78 = ["data-bs-target", "aria-controls"]
const _hoisted_79 = ["id", "aria-labelledby"]
const _hoisted_80 = {
  key: 0,
  class: "accordion-body"
}
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-2 fv-row" }
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { class: "col-md-2 fv-row" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "col-md-2 fv-row" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "col-md-2 fv-row" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-dark btn-light btn-active-warning fw-bold fs-8 w-100",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Reminder ")
], -1)
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-12 fv-row text-end" }
const _hoisted_93 = { class: "modal-body ps-0 pe-0" }
const _hoisted_94 = ["src"]
const _hoisted_95 = {
  key: 1,
  class: "accordion-body"
}
const _hoisted_96 = { class: "row" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100 disabled",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Approve ")
], -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100 disabled",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Deny ")
], -1)
const _hoisted_99 = { class: "col-md-2 fv-row" }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = { class: "col-md-2 fv-row" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-dark btn-light btn-active-warning fw-bold fs-8 w-100",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Reminder ")
], -1)
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "col-12 fv-row text-end" }
const _hoisted_106 = { class: "modal-body ps-0 pe-0" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("p", { class: "text-center pt-5 text-gray-400 fw-bold" }, " Not Uploaded ", -1)
const _hoisted_109 = { class: "col-12 fv-row text-end" }
const _hoisted_110 = { class: "modal-body ps-0 pe-0" }
const _hoisted_111 = {
  class: "collapse",
  id: "kt_advanced_search_form2"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("p", { class: "mt-7 pb-1 pe-2 fs-7 text-gray-600" }, "Document History", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-7" }, null, -1)
const _hoisted_114 = { class: "row" }
const _hoisted_115 = {
  class: "accordion",
  id: "welcome_accordion"
}
const _hoisted_116 = { class: "accordion-item" }
const _hoisted_117 = ["id"]
const _hoisted_118 = ["data-bs-target", "aria-controls"]
const _hoisted_119 = ["id", "aria-labelledby"]
const _hoisted_120 = {
  key: 0,
  class: "accordion-body"
}
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-md-2 fv-row" }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { class: "col-md-2 fv-row" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = { class: "col-md-2 fv-row" }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = { class: "col-md-2 fv-row" }
const _hoisted_129 = ["onClick"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-dark btn-light btn-active-warning fw-bold fs-8 w-100",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Reminder ")
], -1)
const _hoisted_131 = { class: "row" }
const _hoisted_132 = { class: "col-12 fv-row text-end" }
const _hoisted_133 = { class: "modal-body ps-0 pe-0" }
const _hoisted_134 = ["src"]
const _hoisted_135 = {
  key: 1,
  class: "accordion-body"
}
const _hoisted_136 = { class: "row" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100 disabled",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Approve ")
], -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100 disabled",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Deny ")
], -1)
const _hoisted_139 = { class: "col-md-2 fv-row" }
const _hoisted_140 = ["onClick"]
const _hoisted_141 = { class: "col-md-2 fv-row" }
const _hoisted_142 = ["onClick"]
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 fv-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-sm p-2 btn-active-text-dark btn-light btn-active-warning fw-bold fs-8 w-100",
    "data-bs-toggle": "modal",
    "data-bs-target": "#modal_select_product"
  }, " Reminder ")
], -1)
const _hoisted_144 = { class: "row" }
const _hoisted_145 = { class: "col-12 fv-row text-end" }
const _hoisted_146 = { class: "modal-body ps-0 pe-0" }
const _hoisted_147 = { class: "row" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("p", { class: "text-center pt-5 text-gray-400 fw-bold" }, " Not Uploaded ", -1)
const _hoisted_149 = { class: "col-12 fv-row text-end" }
const _hoisted_150 = { class: "modal-body ps-0 pe-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_SmsMessageModal = _resolveComponent("SmsMessageModal")!
  const _component_IboEmailModal = _resolveComponent("IboEmailModal")!
  const _component_EditApplicationModal = _resolveComponent("EditApplicationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, "App ID: " + _toDisplayString(_ctx.app_id), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen052.svg" })
              ]),
              _hoisted_10
            ]),
            _createElementVNode("a", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil005.svg" })
              ]),
              _hoisted_13
            ]),
            _createElementVNode("a", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil005.svg" })
              ]),
              _hoisted_16
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationFiles, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", {
                    class: "accordion-header",
                    id: `welcome_accordion_header_${item.fileid}`
                  }, [
                    _createElementVNode("button", {
                      class: "accordion-button fs-7 fw-normal",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#welcome_accordion_body_${item.fileid}`,
                      "aria-expanded": "true",
                      "aria-controls": `welcome_accordion_body_${item.fileid}`
                    }, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(item.fileid) + ": " + _toDisplayString(item.filetitle), 1),
                      (item.reviewed === '2')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen040.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (item.reviewed === '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen043.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_21)
                  ], 8, _hoisted_20),
                  _createElementVNode("div", {
                    id: `welcome_accordion_body_${item.fileid}`,
                    class: "accordion-collapse collapse",
                    "aria-labelledby": `welcome_accordion_header_${item.fileid}`,
                    "data-bs-parent": "#welcome_accordion"
                  }, [
                    (item.fileurl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            (item.reviewed === '1')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100 disabled",
                                    onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 1))
                                  }, " Approve ", 8, _hoisted_31)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100",
                                    onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 1))
                                  }, " Approve ", 8, _hoisted_33)
                                ])),
                            (item.reviewed === '2')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100 disabled",
                                    onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 2))
                                  }, " Deny ", 8, _hoisted_35)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                    onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 2))
                                  }, " Deny ", 8, _hoisted_37)
                                ])),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-primary fw-bold fs-8 w-100",
                                onClick: ($event: any) => (_ctx.onHideFile(item.fileid, 0))
                              }, " Hide ", 8, _hoisted_39)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                              }, " Remove ", 8, _hoisted_41)
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("button", _hoisted_43, [
                                _createElementVNode("span", _hoisted_44, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
                                ])
                              ]),
                              _createElementVNode("button", _hoisted_45, [
                                _createElementVNode("span", _hoisted_46, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com010.svg" })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("iframe", {
                                  src: item.fileurl,
                                  width: "100%",
                                  height: "500px"
                                }, null, 8, _hoisted_50)
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _hoisted_54,
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-primary fw-bold fs-8 w-100",
                                onClick: ($event: any) => (_ctx.onHideFile(item.fileid, 0))
                              }, " Hide ", 8, _hoisted_56)
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                              }, " Remove ", 8, _hoisted_58)
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("button", _hoisted_60, [
                                _createElementVNode("span", _hoisted_61, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
                                ])
                              ]),
                              _createElementVNode("button", _hoisted_62, [
                                _createElementVNode("span", _hoisted_63, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com010.svg" })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, [
                                  _hoisted_68,
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _createVNode(_component_el_skeleton),
                                      _createVNode(_component_el_skeleton, { style: {"--el-skeleton-circle-size":"50px"} }, {
                                        template: _withCtx(() => [
                                          _createVNode(_component_el_skeleton_item, { variant: "circle" })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                  ], 8, _hoisted_27)
                ])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_71, [
          _hoisted_72,
          _hoisted_73,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesHidden, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("h2", {
                      class: "accordion-header",
                      id: `welcome_accordion_header_${item.fileid}`
                    }, [
                      _createElementVNode("button", {
                        class: "accordion-button fs-7 fw-normal",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": `#welcome_accordion_body_${item.fileid}`,
                        "aria-expanded": "true",
                        "aria-controls": `welcome_accordion_body_${item.fileid}`
                      }, _toDisplayString(item.fileid) + ": " + _toDisplayString(item.filetitle), 9, _hoisted_78)
                    ], 8, _hoisted_77),
                    _createElementVNode("div", {
                      id: `welcome_accordion_body_${item.fileid}`,
                      class: "accordion-collapse collapse",
                      "aria-labelledby": `welcome_accordion_header_${item.fileid}`,
                      "data-bs-parent": "#welcome_accordion"
                    }, [
                      (item.fileurl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 1))
                                }, " Approve ", 8, _hoisted_83)
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 0))
                                }, " Deny ", 8, _hoisted_85)
                              ]),
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-primary fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onHideFile(item.fileid, 1))
                                }, " Unhide ", 8, _hoisted_87)
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                                }, " Remove ", 8, _hoisted_89)
                              ]),
                              _hoisted_90
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("div", _hoisted_93, [
                                  _createElementVNode("iframe", {
                                    src: item.fileurl,
                                    width: "100%",
                                    height: "500px"
                                  }, null, 8, _hoisted_94)
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              _hoisted_97,
                              _hoisted_98,
                              _createElementVNode("div", _hoisted_99, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-primary fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onHideFile(item.fileid, 1))
                                }, " Unhide ", 8, _hoisted_100)
                              ]),
                              _createElementVNode("div", _hoisted_101, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                                }, " Remove ", 8, _hoisted_102)
                              ]),
                              _hoisted_103
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("div", _hoisted_106, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _hoisted_108,
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        _createVNode(_component_el_skeleton),
                                        _createVNode(_component_el_skeleton, { style: {"--el-skeleton-circle-size":"50px"} }, {
                                          template: _withCtx(() => [
                                            _createVNode(_component_el_skeleton_item, { variant: "circle" })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ], 8, _hoisted_79)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_111, [
          _hoisted_112,
          _hoisted_113,
          _createTextVNode(_toDisplayString(_ctx.fileHistory) + " ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesHidden, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("h2", {
                      class: "accordion-header",
                      id: `welcome_accordion_header_${item.fileid}`
                    }, [
                      _createElementVNode("button", {
                        class: "accordion-button fs-7 fw-normal",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": `#welcome_accordion_body_${item.fileid}`,
                        "aria-expanded": "true",
                        "aria-controls": `welcome_accordion_body_${item.fileid}`
                      }, _toDisplayString(item.fileid) + ": " + _toDisplayString(item.filetitle), 9, _hoisted_118)
                    ], 8, _hoisted_117),
                    _createElementVNode("div", {
                      id: `welcome_accordion_body_${item.fileid}`,
                      class: "accordion-collapse collapse",
                      "aria-labelledby": `welcome_accordion_header_${item.fileid}`,
                      "data-bs-parent": "#welcome_accordion"
                    }, [
                      (item.fileurl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("div", _hoisted_122, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-success fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 1))
                                }, " Approve ", 8, _hoisted_123)
                              ]),
                              _createElementVNode("div", _hoisted_124, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onReviewFile(item.fileid, 0))
                                }, " Deny ", 8, _hoisted_125)
                              ]),
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-primary fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onHideFile(item.fileid, 1))
                                }, " Unhide ", 8, _hoisted_127)
                              ]),
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                                }, " Remove ", 8, _hoisted_129)
                              ]),
                              _hoisted_130
                            ]),
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("div", _hoisted_133, [
                                  _createElementVNode("iframe", {
                                    src: item.fileurl,
                                    width: "100%",
                                    height: "500px"
                                  }, null, 8, _hoisted_134)
                                ])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_135, [
                            _createElementVNode("div", _hoisted_136, [
                              _hoisted_137,
                              _hoisted_138,
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-primary fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onHideFile(item.fileid, 1))
                                }, " Unhide ", 8, _hoisted_140)
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm p-2 btn-active-text-white btn-light btn-active-danger fw-bold fs-8 w-100",
                                  onClick: ($event: any) => (_ctx.onDeleteFile(item.fileid))
                                }, " Remove ", 8, _hoisted_142)
                              ]),
                              _hoisted_143
                            ]),
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("div", _hoisted_145, [
                                _createElementVNode("div", _hoisted_146, [
                                  _createElementVNode("div", _hoisted_147, [
                                    _hoisted_148,
                                    _createElementVNode("div", _hoisted_149, [
                                      _createElementVNode("div", _hoisted_150, [
                                        _createVNode(_component_el_skeleton),
                                        _createVNode(_component_el_skeleton, { style: {"--el-skeleton-circle-size":"50px"} }, {
                                          template: _withCtx(() => [
                                            _createVNode(_component_el_skeleton_item, { variant: "circle" })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                    ], 8, _hoisted_119)
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_SmsMessageModal, {
      app_id: _ctx.merchant.app_id,
      ibo_id: _ctx.merchant.ibo_id
    }, null, 8, ["app_id", "ibo_id"]),
    _createVNode(_component_IboEmailModal, {
      app_id: _ctx.merchant.app_id,
      ibo_id: _ctx.merchant.ibo_id
    }, null, 8, ["app_id", "ibo_id"]),
    _createVNode(_component_EditApplicationModal, {
      app_id: _ctx.merchant.app_id,
      ibo_id: _ctx.merchant.ibo_id,
      onSubmit: _ctx.onUpdateIboApplication
    }, null, 8, ["app_id", "ibo_id", "onSubmit"])
  ], 64))
}